import React, { useEffect, useMemo } from 'react'
import { Layout, Spin } from '@surecompanies/core_components'
import { browserHistory } from 'react-router'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import PaymentAssignmentBulkStatusUpload from '../../components/PaymentAssignmentBulkStatus/PaymentAssignmentBulkStatusUpload'
import { FINANCE_PATH } from '../../constants'
import { usePaymentAssignmentUserRoleQuery } from '../../api/payment-assignment-api-client'
import { PaymentAssignmentRole } from '../../components/PaymentAssignment/Utils/roles'

const { Content } = Layout

export default function PaymentAssignmentBulkStatusPage() {
  const {
    data: paymentAssignmentRoleData,
    isFetched: isRoleFetched,
    isLoading: isRoleLoading,
  } = usePaymentAssignmentUserRoleQuery()

  const isChecker = useMemo(
    () => paymentAssignmentRoleData?.role === PaymentAssignmentRole.CHECKER,
    [paymentAssignmentRoleData?.role]
  )

  useEffect(() => {
    if (!isRoleFetched || isRoleLoading) return
    if (!isChecker) {
      browserHistory.push(`${FINANCE_PATH}/payment-assignment`)
    }
  }, [isRoleFetched, isRoleLoading, isChecker])

  return (
    <PageWrapper>
      <Page
        title="Bulk Update Payment Assignment Status"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: FINANCE_PATH },
              {
                title: 'Payment Assignment',
                path: `${FINANCE_PATH}/payment-assignment`,
              },
              { title: 'Bulk Update Status' },
            ]}
          />
        }
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            <Spin spinning={isRoleLoading}>
              {isChecker ? <PaymentAssignmentBulkStatusUpload /> : null}
            </Spin>
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
